const required = (value: string): string | null => (value ? null : 'Campo obrigatório.');

export default required;
